import { render, staticRenderFns } from "./PrivilegeForm.vue?vue&type=template&id=209729ec&"
import script from "./PrivilegeForm.vue?vue&type=script&lang=js&"
export * from "./PrivilegeForm.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports